(ns common.number-utils
  (:require
   [cognitect.transit :as t])
  #?(:clj (:import
           (java.math MathContext))))

;;TODO: refactor other conversion utils from Frontend here if it makes sense - these are now copies of frontend code

#?(:clj
   (def significant-digits
     "The number of significant digits that a double holds for sure. A decimal with
      this many digits or fewer goes to a double and back without a change."
     15))

#?(:clj
   (defn double->bigdec
     "The BigDecimal of the double `d`, rounded to `significant-digits`. The sum of
      two doubles has binary noise: 0.1 plus 0.2 is 0.30000000000000004. The
      rounding gives 0.3."
     [d]
     (-> (BigDecimal. (double d))
         (.round (MathContext. significant-digits))
         (.doubleValue)
         (bigdec))))

(defn bigdec->float
  "The number `bd` as a double. The name is old. A double has 53 bits of precision
   and a 32-bit float has 24, so a 32-bit float gave 23435344 for 23435345.

   A value that is not a number gives nil on both platforms. A calculated function
   reads attributes that can be empty, and it checks the result with `number?`."
  [bd]
  #?(:clj (when (number? bd)
            (double bd))
     :cljs (let [w (t/writer :json)
                 r (t/reader :json
                             {:handlers {"f" (fn [x] (js/parseFloat x))}})]
             (when bd
               (t/read r (t/write w bd))))))

(defn float->bigdec
  "The number `f` as a BigDecimal. On the JVM, a double is rounded to
   `significant-digits`, so that a sum has no binary noise. A BigDecimal and an
   integer keep their exact value. A value that is not a finite number gives nil."
  [f]
  #?(:clj (cond
            (decimal? f)
            f

            (integer? f)
            (bigdec f)

            (and (number? f)
                 (Double/isFinite (double f)))
            (double->bigdec f))
     :cljs (-> f
               str
               t/bigdec)))

(defn ->float
  [numeric-or-bigdec]
  (cond (nil? numeric-or-bigdec)
        0
        (number? numeric-or-bigdec)
        (double numeric-or-bigdec)
        :else
        (bigdec->float numeric-or-bigdec)))

(defn average
  [numbers]
  (/ (->> numbers
          (map ->float)
          (reduce +))
     (count numbers)))

(defn int->letters
  [arg]
  (let [q (int (/ arg 26))
        r (mod arg 26)]
    (str (when (pos? q)
           (int->letters (dec q)))
         (char (+ 97 r)))))

(defn parse-int
  [str-value]
  #?(:clj (Integer/parseInt str-value)
     :cljs (js/parseInt str-value)))

(defn round-decimals
  [value decimals]
  #?(:cljs (let [multiplier (reduce * (repeat decimals 10))]
             (-> value
                 (+ js/Number.EPSILON)
                 (* multiplier)
                 (js/Math.round)
                 (/ multiplier)))
     :clj  (let [multiplier (reduce * (repeat decimals 10))]
             (-> value
                 (+ Double/MIN_VALUE)
                 (* multiplier)
                 (Math/round)
                 (double)
                 (/ multiplier)))))
